import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, get, errMsg } from "@/lib/api";

const FIELDS = [["dpo_name", "DPO / Grievance Officer name", "text"], ["dpo_email", "DPO email", "email"], ["dpo_phone", "DPO phone", "tel"],
  ["notice_version", "Notice text version", "text"], ["retention_days", "Keep data after purpose ends (days)", "number"], ["inactivity_days", "Treat as ended after no activity (days)", "number"]];

export default function PrivacySettings() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["privacy-settings"], queryFn: () => get("/settings/privacy") });
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF(data); }, [data]);
  if (!f) return null;
  const save = async () => {
    try { await api.put("/settings/privacy", { ...f, dpo_email: f.dpo_email || null, retention_days: Number(f.retention_days), inactivity_days: Number(f.inactivity_days) }); toast.success("Privacy settings saved"); qc.invalidateQueries({ queryKey: ["privacy-settings"] }); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="panel space-y-4 p-6" data-testid="privacy-settings-page">
      <div><h2 className="text-lg font-semibold">Privacy (DPDP)</h2>
        <p className="text-sm text-ink-secondary">Your firm is the Data Fiduciary. These details appear in the candidate privacy notice and in every rights-related email. Changing the notice version asks new applicants to agree to the new text.</p></div>
      {!(data.dpo_name && data.dpo_email) && <p className="rounded-[6px] bg-caution-tint px-4 py-2 text-sm text-caution" data-testid="privacy-dpo-missing">No DPO / Grievance Officer set yet. Candidates can still apply, but the notice shows "Not provided yet".</p>}
      <div className="grid gap-3 sm:grid-cols-2">
        {FIELDS.map(([k, l, t]) => (
          <label key={k} className="space-y-1 text-sm"><span className="text-ink-secondary">{l}</span>
            <Input type={t} value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`privacy-${k.replace(/_/g, "-")}-input`} /></label>
        ))}
      </div>
      <p className="text-xs text-ink-muted">Retention: a daily job marks an application's purpose as fulfilled at the hiring decision (or after the inactivity period), emails a deletion notice 48 hours before the end of the retention period, then erases the data. Archived video interviews follow the same rule, counted from the interview date.</p>
      <Button onClick={save} data-testid="privacy-save-btn">Save</Button>
    </section>
  );
}
